module.exports = __webpack_public_path__ + "r-v3/img/stopwatch_basic_blue.fddb4b52.svg";